import { useRef, useState } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';
import isEmpty from 'lodash/isEmpty';

import { Toast } from '@common/overlay-manager';

import { SelectBoxItemOptionValue } from '../../components/SelectBox/select-box-item';
import { SelectBox } from '../../components/SelectBox/SelectBox';
import { useOptionsControl } from '../../hooks/useOptionsControl';

interface AdditionalOptionsContainerProps {
  unlimitAdditionalItems?: boolean;
  disabledPrice?: boolean;
}

export function AdditionalOptionsContainer({
  unlimitAdditionalItems = false,
  disabledPrice,
}: AdditionalOptionsContainerProps) {

  const additional_wrapper_ref = useRef<HTMLDivElement>(null);
  const {
    options,
    textOptions,
    additional_options: additionalOptions,
    has_selected_item,
    addItem,
    resetOptions,
    isItemsShown,
    hasAdditionalFastShippingOption,
  } = useOptionsControl();
  const [active_index, setActiveIndex] = useState(-1);
  const is_accessible = unlimitAdditionalItems || (isItemsShown && has_selected_item);
  const [is_selectbox_expanded, setIsSelectBoxExpanded] = useState(false);
  const isEmptyAdditionalOptions = isEmpty(additionalOptions) || !additionalOptions;
  const option_values =
    additionalOptions && active_index > -1
      ? (additionalOptions[active_index]?.item_list as unknown as SelectBoxItemOptionValue[])
      : [];

  const handleOptionHeightChange = (open: boolean) => {
    if (!additional_wrapper_ref.current) {
      return;
    }

    try {
      const scroll_node = additional_wrapper_ref.current.parentNode;
      const offset_y = additional_wrapper_ref.current.offsetTop - 40;

      if (scroll_node instanceof HTMLElement && open) {
        scroll_node.scrollTo({ top: offset_y, behavior: 'smooth' });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleOptionClick = (i: number) => () => {
    if (!is_accessible) {
      return Toast.show('상위 옵션을 선택해 주세요.');
    }
    setIsSelectBoxExpanded(!is_selectbox_expanded);
    setActiveIndex(i);
  };
  const handleOptionSelect = (item: any) => {
    const selected_item = Object.assign({}, item, {
      options,
      text_options: textOptions,
      count: 1,
      option_type: item.option_type,
      origin_items: [item],
    });

    addItem(selected_item);
    resetOptions();
    setActiveIndex(-1);
    setIsSelectBoxExpanded(false);
  };

  if (isEmptyAdditionalOptions) {
    return null;
  }

  return (
    <Wrapper ref={additional_wrapper_ref} is_only_additional={!!disabledPrice}>
      <header>추가상품</header>
      <SelectBoxHolder>
        {additionalOptions.map(({ id }, i) => (
          <SelectBox
            key={`additional-option-${id}`}
            name='[선택] 추가상품 선택'
            options={option_values}
            active={i === active_index}
            isAccessible={is_accessible}
            hasFastShippingOption={Boolean(hasAdditionalFastShippingOption)}
            onClick={handleOptionClick(i)}
            onOptionHeightChange={handleOptionHeightChange}
            onSelect={handleOptionSelect}
            disabledPrice={disabledPrice}
          />
        ))}
      </SelectBoxHolder>
    </Wrapper>
  );
}

const Wrapper = styled.div<{ is_only_additional: boolean }>`
  margin-top: 20px;
  margin-bottom: -8px;
  ${({ is_only_additional }) => is_only_additional && 'margin-top: -20px;'}
  header {
    font-size: 14px;
    font-weight: 600;
    color: ${vars.v3Color.gray700};
    margin-bottom: 8px;
  }
`;

const SelectBoxHolder = styled.div``;
